import { useSelector } from 'react-redux';
import { getLocale } from '@topconagriculture/profiling';
export const useWeatherParams = (widget) => {
    const userLocale = useSelector(getLocale);
    const { latitude, longitude } = widget.config || {};
    return {
        format: 'metric',
        language: userLocale,
        latitude,
        longitude,
    };
};
//# sourceMappingURL=useWeatherParams.js.map